import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from '@material-ui/core';
import { FIRST_PAGE_INDEX } from 'constants/common';

import { memberDetailActions, selectComment } from 'features/member/reducer/memberDetailSlice';
import DataTableLayout from 'components/common/table/datatable/DataTableLayout';
import CommentTableList from './commentTableList';

import { UpdateCommentItemType } from './commentTableList/column';

import * as S from './MemberComment.styled';

interface Props {
  userId: string;
}

const MemberComment = ({ userId }: Props) => {
  const dispatch = useDispatch();

  const { totalPages } = useSelector(selectComment);

  const [currentPage, setCurrentPage] = useState<number>(FIRST_PAGE_INDEX);
  const [selectedModalType, setSelectedModalType] = useState<UpdateCommentItemType>();

  const onChangeCommentListPage = (pageIndex: number) => {
    setCurrentPage(pageIndex);
    dispatch(memberDetailActions.getCommentList({ userId, page: pageIndex }));
  };

  return (
    <S.MemberCommentBlock>
      <DataTableLayout
        showPagination
        tableTitle={'Comment'}
        maxHeight={'450px'}
        totalPages={totalPages}
        onChangePage={onChangeCommentListPage}
        currentPageIndex={currentPage}
        upperButton={
          <Button
            variant={'contained'}
            size={'small'}
            color={'primary'}
            onClick={() => setSelectedModalType('add')}
          >
            Add Comment
          </Button>
        }
      >
        <CommentTableList
          userId={userId}
          currentPage={currentPage}
          selectedModalType={selectedModalType}
          setSelectedModalType={setSelectedModalType}
        />
      </DataTableLayout>
    </S.MemberCommentBlock>
  );
};

export default MemberComment;
